import { Serialize, InFormGroup, SerializationService as SerSvc } from 'aautil';
import { User } from '@model/user/user';
import { Like } from '@model/like';
import { Likeable } from '@interface/likeable';
import moment from 'moment';
import { MomentService } from '@service/moment.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { LikeableTypeIdentifier } from '@type/likeable-type-identifier';

export class Comment implements Likeable {
  public likeable: boolean = true;
  public likeableTypeIdentifier: LikeableTypeIdentifier = 'chat';

  @Serialize()
  id: number;

  @Serialize({ from: 'user_id', to: false })
  frontend_user_id: number;

  @Serialize({
    from: {
      map: (frontend_user, svc: SerSvc) => svc.deserialize(User, frontend_user),
      deps: [SerSvc],
    },
    to: false,
  })
  frontend_user: User;

  @Serialize({ to: false })
  count_likes: number;

  @Serialize({ to: false })
  userlikes: number[];

  @Serialize({
    from: {
      map: (s: string, momentService: MomentService) => momentService.stringToMoment(s, 'comment.ts_1'),
      deps: [MomentService],
    },
    to: false,
  })
  public created_at: moment.Moment = null;

  @InFormGroup()
  @Serialize()
  message: string;

  // interface likeable
  /////////////////////////////
  @Serialize()
  likes: Like[];

  public modelName(): string {
    return 'Chat';
  }
}
